<template lang="pug">
  include ./../../mixins
  +b.pa--f_1sm.--f_md-md.bg--white.VALIDATION-OBSERVER(
    ref="observer"
    tag="form"
    class="form"
  )
    +b.ma--b_sm.TEXT-BEMTO(
      :fw="'bold'"
      :lh="'large'"
      :fs="['md', '1md-md', 'xl-fhd']"
      :color="'black'"
      :tag="'p'"
    ) QUICK QUOTE
    +b.ug-row--apearance_spaced.--space_md
      +b.ug-cell.ug-cols--12.--6-md(
        v-if="addsField"
      )
        +b.control-cabinet
          +e.element--centered {{ response.manufacturer || '-'}}
      +b.ug-cell.ug-cols--12.--6-md(
        v-if="addsField"
      )
        +b.control-cabinet
          +e.element--centered {{ response.carModel || '-'}}
      +b.ug-cell.ug-cols--12.--6-md(
        :class="{'ug-cols--8-mac': addsField, 'ug-cols--12-mac': !addsField}"
      )
        +b.input.D-CONTROL-INPUT(
          v-model="formData.carRegistration"
          :placeholder="'Car Registration Number'"
          :rules="'required'"
          :name="'carRegistration'"
          :type="'text'"
          id="carRegistration"
        )
      +b.ug-cell.ug-cols--12.--6-md.--4-mac(
        v-if="addsField"
      )
        +b.control-cabinet
          +e.element--centered {{ response.carYear || '-'}}
      +b.ug-cell.ug-cols--12.--6-md.--12-mac
        +b.postal-wrapper
          +b.input.D-CONTROL-INPUT(
            v-model="formData.postCode"
            :placeholder="'Postal Code'"
            :rules="'required'"
            :name="'postCode'"
            :type="'text'"
            id="postCode"
          )
          toggle-mixin-modal(
            :component-name="'GoogleMapModal'"
            :modal-class="'cabinet-modal--size_full'"
          )
            template(#default="{handler}")
              +e.action(
                @click.prevent="handler"
              )
                img(
                  src="/static/img/postcode.png"
                  alt="postcode"
                )
      +b.ug-cell.ug-cols--12.--6-md.--12-mac
        +b.D-CONTROL-OPTION(
          v-model="formData.service"
          :object-list="servicesItems"
          :placeholder="'Choose a service you need'"
          :rules="'required'"
          :name="'service'"
          id="service"
        )
      +b.ug-cell.ug-cols--12.--6-md.--12-mac
        +b.input.D-CONTROL-INPUT(
          v-model="formData.phone"
          :placeholder="'Phone number'"
          :rules="'ukPhone'"
          :name="'phone'"
          :type="'tel'"
          id="phone"
        )
      +b.ug-cell.ug-cols--12.--6-md.--12-mac(
        v-if="addsField"
      )
        +b.control-cabinet
          +e.element--centered.--border
            +b.ug-row--apearance_spaced.--space_xs.--align_center.--justify_between(
              style="width: 100%"
            )
              +b.ug-cell
                +b.TEXT-BEMTO(
                  :fw="'medium'"
                  :lh="'small'"
                  :fs="['1xs']"
                  :color="'black'"
                  :tag="'p'"
                ) Price:
              +b.ug-cell
                +b.TEXT-BEMTO(
                  :fw="'bold'"
                  :lh="'small'"
                  :fs="['xl']"
                  :color="'black'"
                  :tag="'p'"
                ) {{ response.price }} &#163
      +b.ug-cell.ug-cols--12(
        v-if="message"
      )
        +b.ma--b_md.TEXT-BEMTO(
          :cfg="'warning'"
          :fw="'medium'"
          :lh="'small'"
          :fs="['xs']"
          :color="'gray1'"
          :tag="'p'"
        ) Please contact our Manager or Head Office before create an order
        +b.ma--b_md.LINK-BEMTO(
          style="display: block"
          target="_blank"
          v-if="link"
          :fw="'medium'"
          :lh="'small'"
          :fs="['xs']"
          :color="'blue'"
          :href="'https://www.vehiclecheck.co.uk'"
          :tag="'a'"
        ) Get an instant Vehicle Check
        +b.ma--b_xxs.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'small'"
          :fs="['md']"
          :color="'black'"
          :tag="'p'"
        ) {{ objectItem.contactTechnician }}
        +b.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'small'"
          :fs="['md']"
          :color="'black'"
          :tag="'p'"
        ) Head Office - {{ objectItem.contactOffice }}
      +b.ug-cell.ug-cols--12(
        v-if="!createButton"
      )
        +b.button--height_xl.BUTTON-BEMTO(
          :disabled="isRequest"
          @event="validateBeforeSubmit(formData)"
        )
          +e.load.IMG(
            src="/static/load.gif"
            v-if="isRequest"
          )
          +e.text(
            v-if="!isRequest"
          ) GET PRICE NOW
      +b.ug-cell.ug-cols--12(
        v-if="createButton"
      )
        +b.ug-row--apearance_spaced.--space_md
          +b.ug-cell.ug-cols--12.--6-md
            +b.button--height_xl.BUTTON-BEMTO(
              :disabled="isRequest"
              @event="clearQuickQuoteHandler"
            )
              +e.load.IMG(
                src="/static/load.gif"
                v-if="isRequest"
              )
              +e.text(
                v-if="!isRequest"
              ) CLEAR
          +b.ug-cell.ug-cols--12.--6-md
            +b.button--height_xl.ROUTER-LINK(
              :to="{ name: 'NewOrderCabinet', params: {objectItem: response} }"
            ) CREATE ORDER
</template>

<script>
import FormMixin, { defaultValidatorErrorsParser } from '@/js/mixins/FormMixin'
import ToggleModalMixin from '@/js/mixins/ToggleModalMixin'
import {
  postCreateQuoteAPI,
} from '@/js/services/cabinet'

import {
  asyncForEach,
} from '@/js/scripts/helpers'

import {
  eventBus,
} from '@/js/eventBus'

export default {
  name: 'QuickQouteStateForm',
  mixins: [
    FormMixin,
    ToggleModalMixin,
  ],
  props: [
    'servicesItems',
    'objectItem',
  ],
  watch: {
    'formData.phone': {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val) {
          this.formData.phone = null
        }
      },
    },
  },
  mounted() {
    eventBus.$on('postcode:update', data => {
      this.setPostCodeHandler(data)
    })
  },
  data() {
    return {
      /**
       * Component state.
       */
      formData: {
        carRegistration: null,
        postCode: null,
        service: null,
        phone: null,
      },
      response: {},
      isRequest: false,
      addsField: false,
      message: false,
      link: false,
      createButton: false,
    }
  },
  methods: {
    /**
     * Submission handler, if validated.
     * @param { Object } data - Send data.
     */
    async send(data) {
      return postCreateQuoteAPI.execute(
        {}, data
      )
        .then(response => {
          this.response = response.data.item
          if (!response.data.item.request) {
            this.link = true
          } else {
            this.addsField = true
          }
          this.message = true
          this.createButton = true
        })
    },
    async clearQuickQuoteHandler() {
      await asyncForEach(
        Object.keys(this.formData), async key => {
          this.formData[key] = null
        }
      )
      this.$refs.observer.reset()
      this.message = false
      this.createButton = false
      this.link = false
      this.response = {}
    },
    setPostCodeHandler(code) {
      this.formData.postCode = code
    },
    /**
     * After > error display normalization >
     * Set Observer errors.
     *
     * @param { Object } errors - Formatted errors
     */
    setErrors(errors) {
      const error = defaultValidatorErrorsParser(errors)
      this.$refs.observer.setErrors(error)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/QuickQouteStateForm.vue